import { getAllPricings } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { PricingsListEntity } from '@/components/modules/PricingsList/entities/PricingsListEntity';
import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useCache } from '@/hooks/requests/useCache';

const pricingsListInstance = PricingsListEntity.getInstance();

export const usePricingsList = () => {
  const { userEntity } = useUserContext();
  const {
    state: { pricingsListEntity },
    actions: { updateOperationsContext },
  } = useOperationsContext();

  const {
    data: userPricings,
    revalidate: revalidatePricings,
    loading: loadingPricings,
  } = useCache(getAllPricings, { id: userEntity?.user.userId }, { revalidateIfStale: false });

  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    if (userPricings && !pricingsListEntity && userEntity) {
      updateOperationsContext({ pricingsListEntity: pricingsListInstance.setPricings(userPricings, userEntity) });
    }
  }, [userPricings]);

  const getAllPricingsAndLenders = async () => {
    pricingsListInstance.resetPricings();
    await revalidatePricings();
    if (!userPricings || !userEntity) {
      return;
    }
    updateOperationsContext({ pricingsListEntity: pricingsListInstance.setPricings(userPricings, userEntity) });
  };

  const refreshTable = async () => {
    setPage(0);
    await getAllPricingsAndLenders();
  };

  return { pricingsListEntity, page, setPage, refreshTable, loading: loadingPricings };
};
